import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ApiError, AINumberListParams, AINumberListResponse } from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<AINumberListResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchNumberList = async (params: AINumberListParams): Promise<AINumberListResponse> => {
	const url = apiEndpoints.aiNumbers.getList(params);
	const response = await api.get(url);
	return response?.data?.data;
};

const useNumbers = (params: AINumberListParams, options?: QueryOptions) => {
	return useQuery<AINumberListResponse, ApiError>({
		queryKey: ['ai-number', 'list', params],
		queryFn: () => fetchNumberList(params),
		...options,
	});
};

export default useNumbers;
